<template>
    <v-card :loading="isLoading" :class="!addTimeSlot || !timeSlots.length ? 'pb-2' :''" elevation="0" :disabled="isDisabledCard">
        <v-card-title class="d-flex justify-space-between">
            <h4 style="font-weight: 400; font-size: 19px">
                {{ formatDate(day) }}
            </h4>

            <div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            :disabled="addTimeSlot"
                            class="mx-2"
                            @click="addTimeSlot=true"
                            color="green"
                            v-on="on"
                            v-bind="attrs"
                        >
                            mdi-timer-plus-outline
                        </v-icon>
                    </template>
                    <span>Añadir Nueva Franja de Trabajo</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            :disabled="!timeSlots.length"
                            class="mx-2"
                            @click="deleteTimeSlot()"
                            color="red"
                            v-on="on"
                            v-bind="attrs"
                        >
                            mdi-timer-remove-outline
                        </v-icon>
                    </template>
                    <span>Borrar Fichaje de Este Día</span>
                </v-tooltip>
            </div>
        </v-card-title>
        <v-divider class="mx-3 mt-n4"></v-divider>
        <v-card-text class="">
            <div v-if="timeSlots.length">
                <v-row>
                    <v-col cols="8">
                        <div class="d-flex" v-for="timeSlot, index in timeSlots" :key="index">
                            <span><strong>Desde: </strong> {{timeSlot['IN']['time'] ? timeSlot['IN']['time'] : timeSlot['IN'] }}</span>
                            <v-icon small class="d-flex justify-center">mdi-arrow-right</v-icon>
                            <span v-if="timeSlot['OUT']"><strong>Hasta: </strong> {{timeSlot['OUT']['time'] ? timeSlot['OUT']['time'] : timeSlot['OUT'] }}</span>
                            <span v-else class="red--text"><strong>Hasta: </strong> {{ checkPunch() }}</span>

                            <v-icon v-if="timeSlot['OUT']" @click="deleteElement(index)" class="mx-2 mt-n1 align-self-center" size="18" color="red">mdi-delete</v-icon>
                        </div>
                    </v-col>
                    <v-col cols="4" class="align-self-center mx-n2">
                        <h2 class="font-weight-light">{{ totalHours }}</h2>
                    </v-col>
                </v-row>

            </div>
            <div v-if="!addTimeSlot && !timeSlots.length">
                <span>Aún no hay actividad registrada</span>
            </div>
            <div v-if="addTimeSlot">
                <v-row class="d-flex justify-center">
                    <v-col cols="12" md="5" v-if="!incomplete">
                        <v-menu
                            ref="menu1"
                            v-model="sinceMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="sinceTime"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                clearable
                                v-model="sinceTime"
                                label="Desde"
                                prepend-icon="mdi-timer-play-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-time-picker
                                :allowed-hours="allowedSinceHours"
                                :allowed-minutes="allowedSinceMinutes"
                                v-if="sinceMenu"
                                format="24hr"
                                v-model="sinceTime"
                                full-width
                                @click:minute="$refs.menu1.save(sinceTime)"
                            ></v-time-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="2" class="align-self-center" v-if="!incomplete">
                        <v-icon>mdi-arrow-right</v-icon>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-menu
                            ref="menu2"
                            v-model="untilMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="untilTime"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                clearable
                                :disabled="!sinceTime && !incomplete"
                                v-model="untilTime"
                                label="Hasta"
                                prepend-icon="mdi-timer-pause-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-time-picker
                                :allowed-hours="allowedUntilHours"
                                :allowed-minutes="allowedUntilMinutes"
                                v-if="untilMenu"
                                format="24hr"
                                v-model="untilTime"
                                full-width
                                @click:minute="checkValidTime()"
                            ></v-time-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-card
                            v-if="addWarn || saveWarn || errors || incomplete"
                            class="pa-4 my-2 align-self-center"
                            elevation="0"
                        >
                            <template v-if="errors">
                                <span class="d-flex justify-space-around align-self-center red--text">
                                    {{ errors }}
                                    <v-icon color="red">mdi-alert-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-if="addWarn || incomplete">
                                <span class="d-flex justify-space-around align-self-center orange--text">
                                    {{ addWarn ? 'Añade o elimina las fechas selecionadas para poder guardar' :
                                    'El turno está incompleto, añade la hora de salida' }}
                                    <v-icon color="orange">mdi-alert-outline</v-icon>
                                </span>
                            </template>
                            <template v-if="saveWarn">
                                <span class="d-flex justify-space-around align-self-center green--text">
                                    Pulsa guardar, tienes cambios que no se reflejarán
                                    <v-icon color="green">mdi-message-text-outline</v-icon>
                                </span>
                            </template>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
        <v-card-actions class="mt-n6">
            <v-spacer></v-spacer>

            <v-btn @click="addTimeSlot=false" v-if="addTimeSlot && !incomplete" small text color="red">Cancelar</v-btn>
            <v-btn @click="addNewTimeSlot()" v-if="addTimeSlot" small text :disabled="!sinceTime || !untilTime">Añadir</v-btn>
            <v-btn @click="saveTimeSlot()" v-if="addTimeSlot" small depressed color="success" :disabled="disabledSave">Guardar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatDateYYYYMMDD } from '@/util/libUtil.js';
import { clone } from '@/util/libUtil.js'

export default {
    data: () => ({
        addTimeSlot: false,

        sinceTime: null,
        sinceMenu: false,

        untilTime: null,
        untilMenu: false,

        errors: false,
        timeSlots: [],
        incomplete: false,
        completed: false,
    }),
    props: {
        day: null,
        punch: null,
    },
    computed: {
        modified(){
            return this.punch && this.timeSlots.length != Object.keys(this.punch.punches).length
        },
        addWarn(){
            return !this.incomplete && (Boolean(this.sinceTime) || Boolean(this.untilTime))
        },  
        saveWarn(){
            return (!this.punch && this.timeSlots.length) || this.modified
        },
        disabledSave(){
            return !this.saveWarn && !this.addWarn && !this.completed
        },
        isDisabledCard(){
            const today = new Date();
            const day = new Date(this.day);

            day.setHours(today.getHours(), today.getMinutes(), today.getSeconds(), today.getMilliseconds());

            return today < day;
        },
        totalHours(){
            let total = 0;
            this.timeSlots.forEach(timeSlot => {
                if(timeSlot.OUT && 'IN' in timeSlot) {
                    const IN = timeSlot.IN.time ?? timeSlot.IN
                    const OUT = timeSlot.OUT.time ?? timeSlot.OUT
                    let [inHour, inMinute] = IN.split(':')
                    let [outHour, outMinute] = OUT.split(':')

                    total += (outHour - inHour) + (outMinute - inMinute) / 60
                }
            });

            return `${Math.trunc(total)}h ${((total % 1) * 60).toFixed(0)}m`
        },
        ...mapState('punchIn', ['dateFilter', 'isLoading', 'commercial']),
        ...mapGetters('storage', ['getAccountParam']),
    },
    methods: {
        formatDateYYYYMMDD,
        deleteElement(index){
            this.timeSlots.splice(index, 1)

            this.addTimeSlot = true
            if(this.timeSlots.length === 0){
                this.incomplete = false
            }
        },
        checkPunch(){
            this.addTimeSlot = true;
            this.incomplete = true;
            this.sinceTime = this.punch.punches[Object.keys(this.punch.punches).length-1].IN.time ?? this.punch.punches[Object.keys(this.punch.punches).length-1].IN

            return 'Sin Registrar'
        },
        formatDate(date){
            let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            let verboseDate = date.toLocaleDateString('es-ES', options);

            return verboseDate.charAt(0).toUpperCase() + verboseDate.slice(1)
        },
        allowedSinceHours(hour){
            if (hour < 7) return false;
            if(this.timeSlots.at(-1)?.OUT){
                let parsedLastOut = this.timeSlots.at(-1).OUT.time ? this.timeSlots.at(-1).OUT.time.split(':')[0] : this.timeSlots.at(-1).OUT.split(':')[0]

                return hour >= Number(parsedLastOut)
            }
            return true;
        },
        allowedUntilHours(hour){
            if (hour < 7) return false;
            if(this.sinceTime){
                let parsedLastSince = this.sinceTime.split(':')[0]

                return hour >= Number(parsedLastSince)
            }
            return true;
        },
        allowedSinceMinutes(minute){
            if(this.timeSlots.at(-1)?.OUT){
                let parsedSinceHours = document.getElementsByClassName('v-picker__title__btn')[0].textContent
                let parsedUntilHours = this.timeSlots.at(-1).OUT.time ? this.timeSlots.at(-1).OUT.time.split(':')[0] : this.timeSlots.at(-1).OUT.split(':')[0]
                let parsedUntilMinutes = this.timeSlots.at(-1)?.OUT.time ? this.timeSlots.at(-1).OUT.time.split(':')[1] : this.timeSlots.at(-1)?.OUT.split(':')[1]

                if(parsedSinceHours === parsedUntilHours){
                    return minute > Number(parsedUntilMinutes)
                }
            }
            return true;
        },
        allowedUntilMinutes(minute){
            if(this.sinceTime){
                let parsedUntilHours = document.getElementsByClassName('v-picker__title__btn')[0].textContent
                let parsedSinceHours = this.sinceTime?.split(':')[0]
                let parsedSinceMinutes = this.sinceTime?.split(':')[1]

                if(parsedUntilHours === parsedSinceHours){
                    return minute > Number(parsedSinceMinutes) && minute <= 59
                }
            }
            return true;
        },
        deleteTimeSlot(){
            if(this.punch){                
                let deleteObj = {
                    toDeleteId: this.punch.id,
                    toDeleteType: 'PUNCH_IN',
                    isOpenDeleteDialog: true,
                };

                this.$store.commit('util/deleteDialog', clone(deleteObj));
            } else {
                this.incomplete = false
                this.timeSlots = [];
                this.addTimeSlot = false;
                this.sinceTime = null;
                this.untilTime = null;
                this.completed = false;
            }
        },
        addNewTimeSlot(){
            if(!this.incomplete){
                this.timeSlots.push({
                    IN: this.sinceTime,
                    OUT: this.untilTime,
                });
                this.sinceTime = null;
                this.untilTime = null;
            } else {
                this.timeSlots.at(-1)['OUT'] = this.untilTime;
                this.sinceTime = null;
                this.incomplete = false;
                this.completed = true;
            }
        },
        checkValidTime(){
            let since = `${this.sinceTime}:00`;
            let until = `${this.untilTime}:00`;

            if(since >= until){
                this.untilTime = null;
                this.$refs.menu2.save(null);
                this.errors = 'La hora de salida no puede ser menor ni igual a la hora de entrada';

                setTimeout(() => {
                    this.errors = '';
                }, 3000);
            } else {
                this.$refs.menu2.save(this.untilTime);
                this.untilTime = null;
            }
            this.menu2 = false;
        },
        saveTimeSlot() {
            let punches = this.punches ?? []
            let fullTimeSlot = [...this.timeSlots, ...punches];
            let punchesJSON = {}

            fullTimeSlot.forEach((item, index) => {
                punchesJSON[index] = item
            })

            let form = {
                punches: punchesJSON,
                date: this.formatDateYYYYMMDD(this.day),
                commercial: this.getAccountParam(this.commercial)
            }

            if (Object.keys(punchesJSON).length === 0) {
                this.$store.dispatch('punchIn/deletePunchIn', this.punch.id)
            } else if(this.punch){
                form.id = this.punch.id
                this.$store.dispatch('punchIn/editPunchIn', form)
            }else{
                this.$store.dispatch('punchIn/savePunchIn', form)
            }

            this.addTimeSlot = false;
            this.timeSlots = [];
        }
    },
    watch: {
        dateFilter: {
            handler: function () {
                // reset data
                this.sinceTime = null;
                this.sinceMenu = false;
                this.untilTime = null;
                this.untilMenu = false;
                this.addTimeSlot = false;
                this.timeSlots = [];
            },
            deep: true
        },
        sinceTime: {
            handler: function (sinceTime) {
                if(!sinceTime){
                    this.untilTime = null;
                }

                if (this.timeSlots.at(-1)?.OUT) {
                    let since = `${this.sinceTime}:00`;
                    let oldSince = `${this.timeSlots.at(-1).OUT.time ?? this.timeSlots.at(-1).OUT}:00`;

                    if(oldSince >= this.sinceTime) {
                        this.sinceTime = null;
                        this.$refs.menu1.save(null)
                        this.errors = 'La hora de reincorporación debe ser mayor a la de salida';

                        setTimeout(() => {
                            this.errors = '';
                        }, 3000);
                    }
                }
            },
        },
        punch: {
            handler: function (punch) {
                this.timeSlots = [];
                this.incomplete = false
                if(punch){
                    for(const key in punch.punches) {
                        this.timeSlots.push(punch.punches[key])
                    }
                }
            },
            deep: true
        },
        commercial: {
            handler: function (commercial) {
                // clear data
                this.sinceTime = null;
                this.sinceMenu = false;
                this.untilTime = null;
                this.untilMenu = false;
                this.addTimeSlot = false;
                this.timeSlots = [];
            },
            deep: true
        },
    },
    beforeMount(){
        this.timeSlots = [];
        if(this.punch){
            for(const key in this.punch.punches) {
                this.timeSlots.push(this.punch.punches[key])
            }
        }
    }
}
</script>
